export const ROOM_TYPE_FIELD_API_PARAMS = { ordering: 'value' }
